import React from 'react';
import Navbar from "../layout/navigation/v2/navBar";
import Hero from "../layout/banner/Hero";
import ScrollToHash from "../product/ScrollToHash";
import PopularCorals from "./popular-sections/popularCorals";
import {coralsV2} from "../../services/api/data/coral-types-v2";
// import {fish} from "../../services/api/data/fish-types";
import {inverts} from "../../services/api/data/inverts-types";
import FooterXsci from "../layout/footer/footer-xsci";
import PopularCategories from "./popularCategories/popularCategories";


const HomePage: React.FC = () => {


    const findProductByName = (name: string) => {
        // 1. Look through every category
        for (const category of coralsV2) {
            // 2. Look through every subcategory in that category
            for (const sub of (category.subCategories || [])) {
                // 3. Try to find the product in this subcategory
                const found = sub.products?.find(p => p.name === name);
                if (found) return found; // If found, stop searching and return it
            }
        }
        return null; // Return null if it's not anywhere
    };

// Now just call the function with the names:
    const coralA = findProductByName("Green pink tip torch");
    const coralB = findProductByName("Golden aussie branching hammer small colony (3 heads)");
    const coralC = findProductByName("Red yellow center goniopora frag (large)");

// Filter out nulls so your list stays clean
    const topCorals = [coralA, coralB, coralC].filter((p): p is any => p !== null);


    const topInverts = inverts.slice(0, 5);

    return (
        <div style={{backgroundColor:"black"}}>
            {/*<CenteredPageContainer component={() => (*/}
            {/*    <>*/}
            <ScrollToHash />
            <Navbar/>
            <Hero/>
            <PopularCategories/>
            {/*<FeaturedCategories/>*/}
            <PopularCorals
                products={topCorals}
                header={"Popular Corals"}
                productGroup={"corals"}
            />
            {/*<div*/}
            {/*    style={{*/}
            {/*        backgroundImage: "url('/images/banner/divider.jpg')",*/}
            {/*        backgroundSize: "cover",*/}
            {/*        backgroundPosition: "center",*/}
            {/*        backgroundRepeat: "no-repeat",*/}
            {/*        height: "200px",*/}
            {/*        width: "100%"*/}
            {/*    }}*/}
            {/*></div>*/}
            {/*<PopularCorals*/}
            {/*    products={topFish}*/}
            {/*    header={"Best Seller Fish"}*/}
            {/*    productGroup={"fish"}*/}
            {/*/>*/}
            <PopularCorals
                products={topInverts}
                header={"Top Inverts Collection"}
                productGroup={"inverts"}
            />
            <FooterXsci/>
        </div>
        // )} />

        // </>
    );
};

export default HomePage;